import { asyncActionCreator } from '../../shared/redux/actions/common'
import { ADMIN_PROFILE_LOGO_DELETE, FETCH_TENANTS } from '../const'
import { sendJson, patchProperty, sendData, getJson } from '../../shared/utils/api'

export type TenantModel = {
    id: string
    name: string
    login: string
    aboutPage: string
    logo: File
    password: string
    texts: string
    contact: string
    tenantId: string
}

export type Tenant = {
    id: string
    name: string
    aboutPage: string
    texts: string
    contact: string
    logo: File
}

export type TenantUser = {
    id: string
    login: string
    password: string
    tenantId: string
}

interface PasswordInfo {
    currentPassword: string;
    newPassword: string;
}

export const updateAdmin = (tenantUserId: string, admin: TenantModel) => {
    return sendJson(`tenant/${tenantUserId}`, 'PATCH', [
        patchProperty('aboutPage', admin.aboutPage),
        patchProperty('texts', admin.texts),
        patchProperty('contact', admin.contact),
    ])
}

export const updateLogo = (logo: File) => {
    return sendData(`tenant/logo`, 'POST', logo)
}

// need to be id of image
export const deleteLogo = (id: string) => {
    return asyncActionCreator(ADMIN_PROFILE_LOGO_DELETE, () => sendJson(`image/${id}`, 'DELETE'))
}

export const updatePassword = (passwordInfo: PasswordInfo) => {
    return sendJson(`tenant/password`, 'POST', passwordInfo)
}

export const fetchTenants = () => {
    return asyncActionCreator(FETCH_TENANTS, () => getJson('tenant/all'))
}